import { firstPath, type Area, type IconName } from "./model";

export interface PalettePage {
  label: string;
  path: string;
  icon: IconName;
  /** Where the page lives, e.g. "Water · Clients & sites". */
  context: string;
}

export function palettePages(areas: readonly Area[]): PalettePage[] {
  const out: PalettePage[] = [];
  const seen = new Set<string>();
  const add = (p: PalettePage) => {
    if (seen.has(p.path)) return;
    seen.add(p.path);
    out.push(p);
  };
  for (const area of areas) {
    for (const group of area.groups) {
      for (const item of group.items) {
        if (item.external) continue;
        if (!item.tabs) {
          add({ label: item.label, path: item.path, icon: item.icon, context: area.label });
          continue;
        }
        for (const tab of item.tabs) {
          const context = tab.label === item.label ? area.label : `${area.label} · ${item.label}`;
          add({ label: tab.label, path: tab.path, icon: item.icon, context });
        }
      }
    }
  }
  return out;
}

export function areaJumps(areas: readonly Area[]): PalettePage[] {
  return areas.map((a) => ({ label: a.label, path: firstPath(a), icon: a.icon, context: "" }));
}

export function searchPages(pages: readonly PalettePage[], q: string, limit = 6): PalettePage[] {
  const needle = q.trim().toLowerCase();
  if (needle.length < 2) return [];
  const rank = (p: PalettePage) => {
    const label = p.label.toLowerCase();
    if (label.startsWith(needle)) return 0;
    if (label.includes(needle)) return 1;
    if (p.context.toLowerCase().includes(needle)) return 2;
    return 3;
  };
  return pages
    .map((p) => ({ p, r: rank(p) }))
    .filter((x) => x.r < 3)
    .sort((a, b) => a.r - b.r)
    .slice(0, limit)
    .map((x) => x.p);
}
